<template>
    <div class="item" v-clickoutside:hidePicker="{}">
        <div class="title_s">{{ $t('popup_user_reservation.label_status') }}</div>
        <div class="form_s">
            <div class="custom_select">
                <div class="input_xs" @click="action_ClickPicker">
                    <span class="color_circle" :style="backgroundColorString"></span>
                    <span class="txt ellipsis">{{ selectedStateTitle }}</span>
                    <span class="chevron"><v-icon>mdi-chevron-down</v-icon></span>
                </div>
                <div class="list" v-show="isShow">
                    <StatePickerItem
                        v-for="(s, index) in states" :key="index"
                        :state="s"
                        :selectedState="selectedState"
                        @setSelectedState="setSelectedState"
                    />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { sheetState } from '../../../../../sheet-state'
import StatePickerItem from '../Components/StatePickerItem.vue'
export default {
    components: { StatePickerItem },
    props: {
        value: String,
        states: Array
    },
    data() {
        return {
            isShow: false,
            selectedState: undefined,

            sheetState,
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function(newValue) {
                if (this.states == undefined || this.states.length == 0) { return }
                let currentState = this.states.find(s => s._id == newValue) ?? this.states[0]
                this.selectedState = currentState
                
            }
        }
    },
    computed: {
        selectedStateTitle: function() {
            return this.selectedState.title ?? '-'
        },
        colorPalette: function() {
            return this.sheetState.reservationSetting?.statusColorPaletteID
        },
        isBasicPalette: function() {
            // TODO: Check
            return true
        },
        basicPalette: function() {
            return this.colorPalette.basicPalette
        },
        customPalette: function() {
            return this.colorPalette.customPalette
        },
        colorIndex: function() {
            // TODO: custom palette index check
            return this.isBasicPalette ? this.selectedState?.paletteIndex : 0
        },
        colorString: function() {
            return this.isBasicPalette ? this.basicPalette[this.colorIndex] : this.customPalette[this.colorIndex]
        },
        backgroundColorString: function() {
            return 'background-color: ' + this.colorString + ';'
        },
    },
    methods: {
        action_ClickPicker() {
            this.showPicker()
        },

        
        // MARK: - 
        showPicker() {
            this.isShow = true
        },
        hidePicker() {
            this.isShow = false
        },

        // MARK: - 
        setSelectedState(state) {
            this.$emit('input', state._id)
            this.hidePicker()
        }
    }
}
</script>